import LeafRectangleLoader from "../../../../common/leaf/LeafLoadingSkeleton/LeafRectangleLoader/LeafRectangleLoader";
import "./GroupNavigationTileSkeleton.scss";

export const GroupNavigationTileSkeleton = () => (
  <div className="group-navigation-tile-skeleton">
    <div className="group-navigation-tile-skeleton__icon">
      <LeafRectangleLoader isLoading={true} margin="0" styleClass="group-navigation-tile-skeleton__iconLoader" />
    </div>
    <div className="group-navigation-tile-skeleton__content">
      <LeafRectangleLoader isLoading={true} width="12.5rem" height="1.5rem" margin="0" />
    </div>
    <div className="group-navigation-tile-skeleton__arrow" aria-hidden="true">
      <svg width="10" height="18" viewBox="0 0 10 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1.5 1L9 9L1.5 17" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    </div>
  </div>
);

const SKELETON_COUNT = 3;

export const GroupNavigationTileSkeletonList = () => (
  <>
    {Array.from({ length: SKELETON_COUNT }, (_, i) => (
      <div key={i} className="GroupManagementDashboard__tile">
        <GroupNavigationTileSkeleton />
      </div>
    ))}
  </>
);
